<div class="cont-cart-navbar" routerLink="/carrito" id="nav-bar-cart-redirect" [ngClass]="{'cont-cart-navbar-christmas': christmas}" [ngStyle]="{
  'background-color' :  ( (setHeaderStyle?.active || activeCustom) && configStylesHeader?.cart_background_color && !screenSize.mobile) ? configStylesHeader?.cart_background_color : null}">
  <img [src]="cartIcon" alt="Icono de Carrito">
  <div class="circle-cart" *ngIf="quantitySummary">
    <p [ngStyle]="{
      'color' :  ( (setHeaderStyle?.active || activeCustom) && configStylesHeader?.cart_color_text) ? configStylesHeader?.cart_color_text : null}">{{quantitySummary}}</p>
  </div>
</div>

<div class="cont-cart-list" *ngIf="(cart || (enableSas && sasCart)) && quantitySummary > 0">
  <ul>
    <ng-container *ngIf="cart">
      <li *ngFor="let product of cart?.itemList">
        <div class="row">
          <div class="col-sm-3 text-right cont-img">
            <img class="img-thumbnail" [src]="product.mediaImageUrl"
              [alt]="product.description +' '+ product.detailDescription">
            <div *ngIf="countryConfig.cartComponent.inStock && !product.totalStock" class="product-disabled">Producto no
              disponble</div>
          </div>
          <div class="col-sm-9">
            <p class="text-description">
              <strong>{{ product.description }}</strong>
            </p>
            <p class="text-price">
              {{ product.quantitySold }} X {{ product.fullPrice | multiCountryCurrency}}
              <small *ngIf="bolivarDigital">({{ product.fullPrice | multiCountryCurrency:true}})</small>
            </p>
          </div>
        </div>
      </li>

      <li *ngFor="let product of providerList">
        <div class="row">
          <div class="col-sm-3 text-right cont-img">
            <img class="img-thumbnail" [src]="product.mediaImageUrl"
              [alt]="product.description +' '+ product.detailDescription">
            <div *ngIf="countryConfig.cartComponent.inStock && !product.totalStock" class="product-disabled">Producto no
              disponble</div>
          </div>
          <div class="col-sm-9">
            <p class="text-description">
              <strong>{{ product?.description ? product?.description : product?.mediaDescription  }}</strong>
            </p>
            <p class="text-price">
              {{ product.quantitySold }} X {{ product.fullPrice | multiCountryCurrency}}
              <small *ngIf="bolivarDigital">({{ product.fullPrice | multiCountryCurrency:true}})</small>
            </p>
          </div>
        </div>
      </li>
    </ng-container>
    <ng-container *ngIf="enableSas && sasCart">
      <li *ngFor="let product of sasCart.itemList" [hidden]="enableSas && product.onlyOnline">
        <div class="row">
          <div class="col-sm-3 text-right cont-img">
            <img class="img-thumbnail" [src]="product.mediaImageUrl"
              [alt]="product.description +' '+ product.detailDescription">
            <div *ngIf="countryConfig.cartComponent.inStock && !product.totalStock" class="product-disabled">Producto no
              disponble</div>
            <img class="sas-mini-logo" src="assets/svg/subscribe-and-save-petal-logo.svg" alt="Pétalo Logo">
          </div>
          <div class="col-sm-9">
            <p class="text-description">{{ product.description }}</p>
            <p class="text-price">{{ product.quantitySold }} X {{ product.fullPrice | multiCountryCurrency}}</p>
          </div>
        </div>
      </li>
    </ng-container>

  </ul>
  <app-button (click)="gotoCart()" [title]="'Ir al carrito'" [isDisabled]="false"
    [customClasses]="'main full-width text-xs mt-3 mb-2'" [buttonId]="'nav-bar-go-to-cart-button'" [isLoading]="false">
  </app-button>
</div>
